<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activitycode']">
             <a-input  maxLength="50"  v-model="queryParam.activitycode" :placeholder="this.language['cs.activity.activitycode']"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activityname']">
              <a-input  maxLength="50"  v-model="queryParam.activityname" :placeholder="this.language['cs.activity.activityname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.venue.venuename']">
             <a-input  maxLength="50"  v-model="queryParam.venuenames" :placeholder="this.language['cs.venue.venuename']"></a-input>
            </a-form-item>
          </a-col>
         </a-row>
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.startenddate']">
              <a-date-picker width="200"  :placeholder="language['common.chooseStartDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.startdate"></a-date-picker>
                <span class="query-group-split-cust"></span>
                <a-date-picker width="200" :placeholder="language['common.chooseEndDate']" format="YYYY-MM-DD" value-format="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.enddate"></a-date-picker>
       
            </a-form-item>
          </a-col>
          
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary"    @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary"   @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
                <a-button type="primary"  style="margin-left: 8px" icon="download" :disabled="dataSource.length === 0" @click="ExportPersonXls">{{this.language['cs.exportButton.person']}}</a-button>
        <a-button type="primary" style="margin-left: 8px" icon="download" :disabled="dataSource.length === 0" @click="ExportSeatXls" >{{this.language['cs.exportButton.seat']}}</a-button>
     
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <!-- 高级查询区域 -->

      </div>
  
      <!-- table区域-begin -->
      <div>
        <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div> -->
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="sysacid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <!-- <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" >{{this.language['cs.seatassign.detail']}}</a>
  
            <a-divider type="vertical" />
         
            <a @click="handleEdit(record)" >{{this.language['cs.seatassign.view']}}</a>
          </span> -->
        </a-table>
      </div>
 
      
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction ,downFile,downloadFile } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'

    export default {
      name: "SeatReportList",
      mixins:[JeecgListMixin],
      components: {
        
      },
      data () {
        return {
          description: '座位統計報表分析',
          // 表头
         
          url: {
            list: "/ActivityInfo/seatReportList",
            exportPerson:"/ActivityInfo/exportPerson",
            exportSeat:"/ActivityInfo/exportSeat"
          },
        }
      },
      created() {
      },
      mounted(){
      
      }, 
      watch:{

      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['cs.activity.activitycode'],
              align:"center",
              width:150,
              dataIndex: 'activitycode'
            },  
            {
              title:this.language['cs.activity.activityname'],
              align:"left",
              width:150,
              dataIndex: 'activityname'
            },  
            {
              title:this.language['cs.venue.venuename'],
              align:"left",
              width:150,
              dataIndex: 'venuenames'
            },
             {
              title:this.language['cs.activity.startdate'],
              align:"center",
              width:150,
              dataIndex: 'startdate'
            },
            {
              title:this.language['cs.activity.enddate'],
              align:"center",
              width:150,
              dataIndex: 'enddate'
            },
            {
              title:this.language['cs.activity.seatstartdate'],
              align:"center",
              width:150,
              dataIndex: 'seatstartdate'
            },
            {
              title:this.language['cs.activity.seatenddate'],
              align:"center",
              width:150,
              dataIndex: 'seatenddate'
            }, 
            {
              title:this.language['cs.seat.persontotalqty'],
              align:"right",
              width:150,
              dataIndex: 'persontotalqty'
            },  
            {
              title:this.language['cs.seat.assignpersonqty'],
              align:"right",
              width:150,
              dataIndex: 'assignpersonqty'
            },
            {
              title:this.language['cs.seat.notassignpersonqty'],
              align:"right",
              width:150,
              dataIndex: 'notassignpersonqty'
            },

            {
              title:this.language['cs.seat.checkseatqty'],
              align:"right",
              width:150,
              dataIndex: 'checkseatqty'
            },
            {
              title:this.language['cs.seat.seizeseatqty'],
              align:"right",
              width:150,
              dataIndex: 'seizeseatqty'
            },
            {
              title:this.language['cs.seat.lockseatqty'],
              align:"right",
              width:150,
              dataIndex: 'lockseatqty'
            },
            {
              title:this.language['cs.seat.notcheckseatqty'],
              align:"right",
              width:150,
              dataIndex: 'notcheckseatqty'
            },
            {
              title:this.language['cs.seat.seattotalqty'],
              align:"right",
              width:150,
              dataIndex: 'seattotalqty'
            }
            // , 
            // {
            //   title: '操作',
            //   dataIndex: 'action',
            //   align:"center",
            //   fixed:"right",
            //   width:147,
            //   scopedSlots: { customRender: 'action' },
            // }
          ]
          }
        }
      },
      methods: {
        ExportPersonXls(){
 
          let params="";
          if(this.queryParam.activitycode!=null)
          {
            params=params+"activitycode="+this.queryParam.activitycode
          }
          if(this.queryParam.activityname!=null)
          {
            params=params +"&activityname="+this.queryParam.activityname
          }
          if(this.queryParam.activityname!=null)
          {
            params=params +"&venuenames="+this.queryParam.venuenames
          }
          if(this.queryParam.startdate!=null)
          {
            params=params +"&startdate="+this.queryParam.startdate
          } 
          if(this.queryParam.enddate!=null)
          {
            params=params   +"&enddate="+this.queryParam.enddate;
          }
      
     

        let url =window._CONFIG['chooseSeatDomainURL']+ "/ActivityInfo/exportPerson?"+params
        downloadFile(url,'PersonList.xlsx');
      
        },
        ExportSeatXls(){
          
          let params="";
          if(this.queryParam.activitycode!=null)
          {
            params=params+"activitycode="+this.queryParam.activitycode
          }
          if(this.queryParam.activityname!=null)
          {
            params=params +"&activityname="+this.queryParam.activityname
          }
          if(this.queryParam.activityname!=null)
          {
            params=params +"&venuenames="+this.queryParam.venuenames
          }
          if(this.queryParam.startdate!=null)
          {
            params=params +"&startdate="+this.queryParam.startdate
          } 
          if(this.queryParam.enddate!=null)
          {
            params=params   +"&enddate="+this.queryParam.enddate;
          } 
          let url =window._CONFIG['chooseSeatDomainURL']+ "/ActivityInfo/exportSeat?"+params
//let url =window._CONFIG['chooseSeatDomainURL']+ "/PersonInfo/DownLoadTemplate"
downloadFile(url,'SeatList.xlsx');
},

        searchQuery() {
        
        this.loadData(1);
        },
     
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>